import React from 'react';
import { Loader2 } from 'lucide-react';

interface FullScreenLoaderProps {
  message: string;
  submessage?: string;
}

export const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ message, submessage }) => {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="text-center space-y-6 px-6">
        <div className="relative">
          <div className="w-24 h-24 mx-auto">
            <Loader2 className="w-24 h-24 text-blue-600 animate-spin" strokeWidth={2} />
          </div>
          <div className="absolute inset-0 w-24 h-24 mx-auto">
            <div className="w-full h-full rounded-full bg-blue-100 animate-ping opacity-20"></div>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-2xl font-bold text-gray-900">{message}</h2>
          {submessage && (
            <p className="text-base text-gray-600 max-w-md mx-auto leading-relaxed">
              {submessage}
            </p>
          )}
        </div>

        <div className="flex justify-center gap-2 pt-4">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};
